import React from "react";
import Routes from "@config/routes";
import {QueryClientProvider, QueryClient, useQuery} from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import moment from "moment";
import 'moment/locale/es';
moment.locale("es")

const queryClient = new QueryClient();

function App() {
    return (
        <QueryClientProvider client={queryClient}>
            <Routes/>
            <ReactQueryDevtools initialIsOpen={false}/>
        </QueryClientProvider>
    );
}

export default App;
